import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { Toast } from 'primeng/toast';
import { ConfirmationDialogComponent } from './core/component/confirmation-dialog/confirmation-dialog.component';
import { LoaderComponent } from './core/component/loader/loader.component';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, Toast, ConfirmationDialogComponent, LoaderComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent {
  title = 'Momentum';
}
